import React, { useEffect, useState } from "react";

import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import { actions } from "../../../../app/categoriesSlice";
import CoreSpinner from "../../../../app/core/components/CoreSpinner/CoreSpinner";
import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableContainer,
  Paper,
  IconButton,
  Tooltip,
  Divider,
} from "@mui/material";
import { useLocation } from "react-router-dom";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import LinkIcon from "@mui/icons-material/Link";
import LinkOffIcon from "@mui/icons-material/LinkOff";
import { toast } from "react-toastify";
import CoreModal from "../../../../app/core/components/CoreModal/CoreModal";
import { formattaData } from "../../../../utils/functions/date-utils";
import { TABLE_ROWS_NUMBER } from "../../../../utils/constants/tables";
import {
  useGetUserDocumentsQuery,
  useGetPracticeByIdQuery,
  useAddAssociateDocumentMutation,
  useDeleteAssociateDocumentMutation,
} from "../../../api/user/gestisciPraticheApi";
import { useGetUserCategoriesQuery } from "../../../api/user/categoriesApi";
import CorePreviewDoc from "../../../../app/core/components/CorePreviewDoc/CorePreviewDoc";
import { t } from "i18next";
import { useDispatch, useSelector } from "react-redux";
import PracticeDocumentFilter from "./PracticeDocumentFilter";
import CorePagination from "../../../../app/core/components/CorePagination/CorePagination";
import { labelForFilterDoc } from "../../../../utils/functions/filters";
import CoreChip from "../../../../app/core/components/CoreChip/CoreChip";
import { useGetDocumentByIdQuery } from "../../../api/user/gestisciDocumentiApi";
import CoreBack from "../../../../app/core/components/CoreBack/CoreBack";

const DocumentiPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const categories = useSelector((state) => state.categories.macroCategories);

  const { id } = useParams();

  const searchParams = new URLSearchParams(location.search);
  const categoriaParam = searchParams.get("categoria");

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedDoc, setSelectedDoc] = useState(null);
  const [filter, setFilter] = useState({
    mainCategoryId: "",
    categoryId: categoriaParam || "",
  });
  const [page, setPage] = useState({
    currentPage: 1,
    startRow: 0,
    endRow: TABLE_ROWS_NUMBER,
  });

  //API
  const { data, isLoading } = useGetPracticeByIdQuery(id);
  const { data: dati, isLoading: Caricamento } = useGetUserDocumentsQuery({
    id: id,
    filter: {
      ...filter,
      exclusive: false,
    },
    page,
  });

  const { data: singleDoc, isLoading: loadingDoc } = useGetDocumentByIdQuery(
    selectedDoc,
    {
      skip: !selectedDoc,
    }
  );

  const { data: datas, isLoading: Loading } = useGetUserCategoriesQuery({
    page,
  });

  const [addAssociateDocument] = useAddAssociateDocumentMutation();
  const [deleteAssociateDocument] = useDeleteAssociateDocumentMutation();

  useEffect(() => {
    if (datas?.Data) dispatch(actions.setMacroCategories(datas?.Data));
  }, [datas, dispatch]);

  const openModal = (doc) => {
    setIsModalOpen(true);
    setSelectedDoc(doc);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const handleLinkOffClick = async (docId) => {
    const now = new Date().toISOString();
    const body = {
      id: id,
      practiceId: id,
      documentId: docId,
      mandatory: true,
      //createdAt: now,
    };
    addAssociateDocument(body)
      .then((res) => {
        toast.success(t("DocAdded"));
      })
      .catch((error) => {
        toast.error(t("DocNotAdded"));
      });
  };

  const handleRemoveFilter = (f) => {
    let newFilter = { ...filter };
    Object.entries(newFilter).forEach(([k, v]) => {
      if (v === f) newFilter[k] = "";
    });
    setFilter(newFilter);
  };

  const handleDocumentDelete = (docId) => {
    const params = {
      practiceId: id,
      documentId: docId,
    };
    deleteAssociateDocument(params)
      .then(() => {
        toast.success(t("DocRemovedPractice"));
      })
      .catch((error) => {
        toast.error(t("DocNotRemovedPractice"));
      });
  };

  if (isLoading || Caricamento || loadingDoc) {
    return <CoreSpinner />;
  }

  return (
    <div className="p-4">
      <div className="flex justify-center w-full mb-4 items-center">
        <CoreBack />
        <div className="w-11/12 flex items-center justify-between">
          <h2 className="fw-bold">{data?.Data?.name}</h2>
        </div>
      </div>
      <div className="flex flex-row -mt-16 justify-end space-x-2">
        {Object.entries(filter).map(
          ([k, v]) =>
            v !== "" && (
              <CoreChip
                key={v}
                label={labelForFilterDoc(k, v, categories)}
                variant="outlined"
                onDelete={() => handleRemoveFilter(v)}
              />
            )
        )}
        <PracticeDocumentFilter
          filter={filter}
          setFilter={setFilter}
          setPage={setPage}
        />
        {/* FIlter component */}
      </div>
      <div className="w-full mt-10">
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>{t("Name")}</TableCell>
                <TableCell>{t("Date")}</TableCell>
                <TableCell>{t("Uploaded")}</TableCell>
                <TableCell>{t("Amount")}</TableCell>
                <TableCell>{t("Category")}</TableCell>
                <TableCell>{t("Actions")}</TableCell>
              </TableRow>
            </TableHead>
            {dati?.Data?.items?.map((documento) => (
              <TableRow className="hover:shadow-md" key={documento.id}>
                <TableCell>{documento.name}</TableCell>
                <TableCell>{formattaData(documento.date)}</TableCell>
                <TableCell>{formattaData(documento.createdAt)}</TableCell>
                <TableCell>{documento.amount}</TableCell>
                <TableCell>{documento.categoryName}</TableCell>
                <TableCell>
                  <Tooltip title="Dettaglio">
                    <IconButton
                      onClick={() => openModal(documento.id)}
                      className="w-10 h-10"
                    >
                      <SearchRoundedIcon />
                    </IconButton>
                  </Tooltip>

                  {documento.associatedWithPractice ? (
                    <Tooltip title={t("RemovePracticeDoc")}>
                      <IconButton
                        className="w-10 h-10"
                        onClick={() => handleDocumentDelete(documento.id)}
                      >
                        <LinkIcon />
                      </IconButton>
                    </Tooltip>
                  ) : (
                    <Tooltip title={t("AddPracticeDoc")}>
                      <IconButton
                        onClick={() => handleLinkOffClick(documento.id)}
                        className="w-10 h-10 text-red-600"
                      >
                        <LinkOffIcon />
                      </IconButton>
                    </Tooltip>
                  )}
                </TableCell>
              </TableRow>
            ))}
            {dati?.Data?.items?.length === 0 && (
              <TableRow>
                <TableCell colSpan={6} className="text-center text-gray">
                  {t("NoDocs")}
                </TableCell>
              </TableRow>
            )}
          </Table>
        </TableContainer>
        <Divider />
        <div className="w-full flex justify-center">
          <CorePagination
            page={page}
            setPage={setPage}
            totalPages={Math.ceil(dati?.Data?.count / TABLE_ROWS_NUMBER) || 1}
          />
        </div>
      </div>
      <CoreModal
        component={<CorePreviewDoc singleDoc={singleDoc?.Data} />}
        state={isModalOpen}
        onClose={closeModal}
        width={"80%"}
        height={"95%"}
      />
    </div>
  );
};

export default DocumentiPage;
